export default __webpack_public_path__ + "static/background_item_numbers-c1b9f4a481cbc979dcdeb77a24922102.png";